function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var IresetCircleRed = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    notChangeable: true,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10",
    fill: "#E4464A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6127 12.7922C16.3205 12.6994 16.0083 12.8611 15.9149 13.1533C15.3944 14.79 13.8622 15.8889 12.1022 15.8889C9.90109 15.8889 8.1111 14.1444 8.1111 12C8.1111 9.85611 9.90109 8.11111 12.1022 8.11111C13.0622 8.11111 13.9677 8.44556 14.6827 9.03889L13.4794 8.84056C13.1738 8.785 12.8905 8.99556 12.8405 9.29778C12.7905 9.60056 12.9955 9.88667 13.2983 9.93611L15.6572 10.3261C15.6877 10.3311 15.7188 10.3333 15.7483 10.3333C15.8144 10.3333 15.8788 10.3217 15.9388 10.2994C15.9594 10.2917 15.9761 10.2772 15.9961 10.2667C16.0327 10.2478 16.0711 10.2311 16.1027 10.2044C16.1227 10.1883 16.1355 10.165 16.1527 10.1461C16.1788 10.1189 16.2066 10.0928 16.226 10.0594C16.2399 10.0356 16.2455 10.0072 16.256 9.98056C16.2694 9.94778 16.2872 9.91722 16.2938 9.88111L16.7127 7.65889C16.7694 7.35722 16.571 7.06611 16.2694 7.01C15.9688 6.95556 15.6772 7.15167 15.6205 7.45278L15.4694 8.25333C14.5449 7.45278 13.36 7 12.1022 7C9.28887 7 7 9.24278 7 12C7 14.7572 9.28887 17 12.1022 17C14.3477 17 16.3055 15.5894 16.9738 13.49C17.0666 13.1978 16.9049 12.8856 16.6127 12.7922Z",
    fill: "white"
  }));
});